import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var BandAid = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M8.111 21.889a5.962 5.962 0 004.242-1.757l7.778-7.778a6.007 6.007 0 000-8.485 5.965 5.965 0 00-4.243-1.757 5.962 5.962 0 00-4.242 1.757l-7.778 7.778a6.007 6.007 0 000 8.485 5.965 5.965 0 004.243 1.757zm-2.829-8.828l7.778-7.778a3.976 3.976 0 012.828-1.171c1.069 0 2.073.416 2.829 1.171a4.006 4.006 0 010 5.657l-7.778 7.778a3.976 3.976 0 01-2.828 1.171 3.977 3.977 0 01-2.829-1.171 4.008 4.008 0 010-5.657z",
    key: "k0"
  }), React.createElement("circle", {
    cx: 9,
    cy: 12,
    r: 1,
    key: "k1"
  }), React.createElement("circle", {
    cx: 15,
    cy: 12,
    r: 1,
    key: "k2"
  }), React.createElement("circle", {
    cx: 12,
    cy: 15,
    r: 1,
    key: "k3"
  }), React.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 1,
    key: "k4"
  }));
});
BandAid.displayName = 'BandAid';
export var BandAidDimensions = {
  height: 24,
  width: 24
};